import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule } from '@angular/material/core';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatCardModule } from '@angular/material/card';
import { AgGridModule } from 'ag-grid-angular';
import { PlanningEntryTableComponent } from './planning-entry-table.component';
import { MatDividerModule } from '@angular/material/divider';
import { NgSelectModule } from '@ng-select/ng-select';
@NgModule({
  declarations: [PlanningEntryTableComponent],
  imports: [
    CommonModule, FormsModule, ReactiveFormsModule, MatButtonModule, MatCheckboxModule,NgSelectModule,
    MatDatepickerModule, MatDialogModule, MatFormFieldModule, MatIconModule, MatInputModule,
    MatNativeDateModule, MatRadioModule, MatSelectModule, MatSlideToggleModule, MatCardModule, AgGridModule,MatDividerModule,
  ],
  exports: [PlanningEntryTableComponent]
})
export class PlanningEntryModule {}